var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgKickPlatform = function SvgKickPlatform(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 113,
    viewBox: "0 0 100 113",
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H37.5055V25.011H50V12.5165H62.4945V0H100V37.5055H87.5055V50H75.011V62.4945H87.5055V74.989H100V112.494H62.4945V100H50V87.5055H37.5055V112.517H0V0Z",
    fill: "#53FC18"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgKickPlatform);
export default ForwardRef;